import SlideFrame from "./_SlideFrame";
import { Check, X } from "lucide-react";

export default function SlideBetterWay() {
  const columns = [
    {
      title: "Tech Platforms",
      kind: "Infrastructure-only",
      pros: ["Strong APIs & infrastructure", "Flexible & modern", "Self-serve tooling"],
      cons: ["No servicing agents or execution", "You hire, train, run the operation"],
    },
    {
      title: "Traditional Servicers",
      kind: "Ops-only",
      pros: ["Full operational support", "Established workflows"],
      cons: ["Outdated core systems", "Rigid contracts & limited flexibility", "Slow onboarding"],
    },
    {
      title: "IBA Servicing",
      kind: "Infrastructure + Operators",
      featured: true,
      pros: [
        "Modern API-driven core (LoanPro)",
        "Operator-led execution at scale",
        "Flat, transparent pricing",
        "AI-enhanced call center & workflows",
      ],
      cons: [],
    },
  ];

  return (
    <SlideFrame tag="02 · The Gap">
      <p className="overline mb-6">The choice today</p>
      <h2 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-5xl">
        Lenders are forced to pick between <em className="italic">great tech</em> and <em className="italic">a trusted team</em>. <span className="text-primary">We deliver both.</span>
      </h2>

      <div className="mt-12 grid md:grid-cols-3 gap-px bg-foreground/20 border border-foreground/20">
        {columns.map((c, i) => (
          <div
            key={i}
            className={`p-8 md:p-10 ${c.featured ? "bg-background border-t-4 border-t-primary" : "bg-background"}`}
          >
            <p className={`text-[11px] uppercase tracking-brand font-bold ${c.featured ? "text-primary" : "text-muted-foreground"}`}>
              {c.kind}
            </p>
            <h3 className="font-display text-3xl md:text-4xl tracking-tight mt-3">{c.title}</h3>
            <ul className="mt-6 space-y-3">
              {c.pros.map((p) => (
                <li key={p} className="flex gap-3 text-sm leading-relaxed">
                  <Check className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={2} />
                  {p}
                </li>
              ))}
              {c.cons.map((p) => (
                <li key={p} className="flex gap-3 text-sm leading-relaxed opacity-70">
                  <X className="w-4 h-4 mt-0.5 flex-shrink-0" strokeWidth={2} />
                  {p}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="mt-10 text-sm text-muted-foreground italic font-display text-xl">
        You shouldn&rsquo;t have to choose.
      </p>
    </SlideFrame>
  );
}
